import React, { useContext, useEffect, useState } from 'react';
import { Button, Drawer, Image, Layout, Menu, MenuProps, theme } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import Sider from 'antd/es/layout/Sider';
import { Content, Header } from 'antd/es/layout/layout';
import styles from './styles.module.scss';
import BANNER_LOGO from '../assets/images/banner_logo.png';
import * as Navigation from '../config/navigation';
import DesktopNavigation from './page/navigation/desktop';
import useWindowDimensions from '../utilities/hooks/windows/dimensions';
import Media from 'react-media';
import Breakpoints from '../utilities/files/breakpoints';
import Loading from '../components/loading/Loading';
import { MethodsContext } from '../context';

interface Props {
  children: React.ReactNode;
  loading?: boolean;
  menuCollapsed?: boolean;
}

type MenuItem = Required<MenuProps>['items'][number];

const Page: React.FC<Props> = ({ children, loading }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusOuter },
  } = theme.useToken();
  const [navItems, setNavItems] = useState([]);
  const [smallerScreen, setSmallerScreen] = useState(false);
  const { width } = useWindowDimensions();
  const globalMethods = useContext(MethodsContext);

  useEffect(() => {
    const nav = [...Navigation.mainNav];

    const finalNav = nav.map((obj: Navigation.NavItemModel) => {
      return getNavItem(obj.label, obj.key, obj.icon);
    });

    function getNavItem(label: string | React.ReactNode, key: React.Key, icon?: React.ReactNode): MenuItem {
      return {
        key,
        label,
        icon,
      };
    }

    setNavItems(finalNav);
  }, []);

  useEffect(() => {
    globalMethods.setMenuCollapsed(collapsed);
  }, [collapsed]);

  useEffect(() => {
    if (width >= 992 && width <= 1200) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }

    if (width >= 769 && width <= 992) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }

    if (width <= 768) {
      setSmallerScreen(true);
    } else {
      setSmallerScreen(false);
    }
  }, [width]);

  const closeDrawer = () => {
    setOpenDrawer(false);
  };

  return (
    <>
      <Layout style={{ minHeight: '100vh', overflow: 'auto' }} className={styles.layout_wrapper}>
        <Media queries={Breakpoints}>
          {(matches) =>
            matches.sm || matches.xs ? (
              <Drawer
                headerStyle={{ display: 'none' }}
                open={openDrawer}
                placement="left"
                onClose={() => setOpenDrawer(false)}
                width={225}
                style={{ background: '#120338' }}
                zIndex={1000000000}
                bodyStyle={{ padding: 0 }}
              >
                <div className={styles.demo_logo_vertical}>
                  <Image src={BANNER_LOGO} className={styles.logo} alt="Banner Logo" />
                  <span className={styles.logo_text}>Banners</span>
                </div>
                <DesktopNavigation navItems={navItems} onClickMenuItem={closeDrawer} />
              </Drawer>
            ) : (
              <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                style={{
                  background: '#120338',
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  height: '100vh',
                  zIndex: 100,
                }}
                width="224px"
              >
                <div className={styles.demo_logo_vertical}>
                  <Image src={BANNER_LOGO} className={styles.logo} alt="Banner Logo" />
                  <span className={styles.logo_text}>Banners</span>
                </div>
                <DesktopNavigation navItems={navItems} />
              </Sider>
            )
          }
        </Media>

        <Layout>
          <Media queries={Breakpoints}>
            {(matches) =>
              matches.sm || matches.xs ? (
                <>
                  <Header
                    className={styles.header_wrapper}
                    style={{
                      padding: 0,
                      background: colorBgContainer,
                      marginLeft: collapsed ? '80px' : '0',
                    }}
                  >
                    <Button
                      type="text"
                      icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                      onClick={!smallerScreen ? () => setCollapsed(!collapsed) : () => setOpenDrawer(!openDrawer)}
                      className={styles.hamburger_icon}
                      style={{ background: 'transparent' }}
                    />
                    <span className={styles.header_title}>Banners [EVALUATION]</span>
                  </Header>
                  <Content className={styles.content} style={{ marginLeft: collapsed ? '80px' : '0' }}>
                    {children}
                  </Content>
                </>
              ) : (
                <>
                  <Header
                    className={styles.header_wrapper}
                    style={{
                      padding: 0,
                      background: colorBgContainer,
                      marginLeft: collapsed ? '80px' : '224px',
                    }}
                  >
                    <Button
                      type="text"
                      icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                      onClick={!smallerScreen ? () => setCollapsed(!collapsed) : () => setOpenDrawer(!openDrawer)}
                      className={styles.hamburger_icon}
                      style={{ background: 'transparent' }}
                    />
                    <span className={styles.header_title}>Banners [EVALUATION]</span>
                  </Header>
                  <Content className={styles.content} style={{ marginLeft: collapsed ? '80px' : '224px' }}>
                    {children}
                  </Content>
                </>
              )
            }
          </Media>
        </Layout>
      </Layout>
      {loading && <Loading tip="Generating Banner Suggestions...." />}
    </>
  );
};

export default Page;
